{
  "success": true,
  "token": "refreshed-session-token"
}
